// extracted by mini-css-extract-plugin
module.exports = {"root":"AmountSection_root__i0gvk","amount":"AmountSection_amount__iE2UX","usdAmount":"AmountSection_usdAmount__3_NyO"};